// extracted by mini-css-extract-plugin
export default {"bodyLogin":"login_bodyLogin__3t4iO","login":"login_login__XWvWZ","input":"login_input__CsLCQ","error":"login_error__ZLldf","btn":"login_btn__j2KFS"};